import { StrictMode } from 'react';

interface StrictModeWrapperProps {
    children: React.ReactNode;
    enableStrictMode: boolean;
}

export const StrictModeWrapper = ({ children, enableStrictMode }: StrictModeWrapperProps) =>
    enableStrictMode ? <StrictMode>{children}</StrictMode> : <>{children}</>;
